/* eslint-disable react/prop-types */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { AppStoreIcon } from 'components';

const ModalBody = styled(Modal.Header)`
  display: block;
  text-align: center;
  border: none;
  font-family: 'Source Sans Pro', sans-serif;
  .box {
    padding: 50px;
  }
`;

const LinkButton = styled.button`
  color: #222;
  font-size: 18px;
  font-weight: 500;
  background: transparent;
  border: none;
  padding: 0;
`;
const StoresModal = ({ visible, setVisible }) => {
  return (
    <>
      <Modal show={visible} dialogClassName="modal-90w" centered onHide={() => setVisible(false)}>
        <ModalBody>
          <div className="box">
            <h3>
              Baixe o nosso
              <br />
              Aplicativo
            </h3>
            <a
              href="https://play.google.com/store/apps/details?id=com.cgsconsultoria.querotrabalhar&hl=en"
              target="blank"
            >
              <AppStoreIcon store="google-play" />
            </a>
            <a href="/">
              <AppStoreIcon />
            </a>
          </div>
          <LinkButton onClick={() => setVisible(false)}>Fechar</LinkButton>
        </ModalBody>
      </Modal>
    </>
  );
};

export default StoresModal;
